import * as tslib_1 from "tslib";
/* I122 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Subfolders = /** @class */ (function (_super) {
    tslib_1.__extends(Subfolders, _super);
    function Subfolders() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subfolders.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "0 0 24 24" },
                React.createElement("path", { d: "M5 11h14v10H5V11zm2 2v4h10v-4H7zm0-6h10v2H7V7zm2-3.002h6V5H9V3.998z", stroke: "currentColor" }))));
    };
    return Subfolders;
}(React.Component));
export { Subfolders };
export default Subfolders;
//# sourceMappingURL=Subfolders.js.map